import { RouteObject } from 'react-router-dom';
import { mainRoutes } from './mainRoutes';
import { adminRoutes } from './adminRoutes';
import { adminV2Routes } from './adminV2Routes';
import { sampleNoteRoutes } from './sampleNoteRoutes';
import { devRoutes } from './devRoutes';
import { knowledgeBaseRoutes } from './knowledgeBaseRoutes';

// Define a type for conditionally adding routes to emphasize type checking
type ConditionalRouteGroup = {
  condition: boolean;
  routes: RouteObject[];
};

export function addConditionalRoutes(
  mainRoutes: RouteObject[],
  ...conditionalGroups: ConditionalRouteGroup[]
): RouteObject[] {
  return [
    ...mainRoutes,
    ...conditionalGroups.reduce(
      (acc, group) => (group.condition ? [...acc, ...group.routes] : acc),
      [] as RouteObject[],
    ),
  ];
}

export const getRouter = () => {
  const isAdmin = import.meta.env.VITE_BUILD_ENV !== 'production';

  return addConditionalRoutes(
    [...mainRoutes, ...sampleNoteRoutes, ...knowledgeBaseRoutes],
    {
      condition: isAdmin,
      routes: [...adminRoutes, ...adminV2Routes],
    },
    {
      condition: import.meta.env.DEV,
      routes: devRoutes,
    },
  );
};
